<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                Why Us ?
            </h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Why Us?</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->
<section class="team-area">
    <div class="ai-solution-area  common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="media col-lg-5 col-md-12 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/9195061.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-12 col-sm-12">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px  ;
                                line-height: 59px ;
                                margin-bottom: 0px  ;
                            ">
                            Make Your Business More Competitive And Sustainable.
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px  ;
                                line-height: 38px  ;
                                margin-top: 50px;
                                margin-bottom: 35px  ;
                            ">
                            Vocbot is a voice-interacting solution developed to give users a personalized feel
                            We are a team of passionate professionals who want to address problems that have not been
                            addressed yet. <br>
                            Focus on User Experience: We prioritize creating voice-based solutions that are not only
                            functional but also delightful to interact with. <br>
                            Scalable Solutions: Our solutions are designed to grow with your business needs.
                            Commitment to Innovation: We're constantly pushing the boundaries of voice technology to
                            deliver the most advanced solutions possible.

                            <br><br>
                            Industry Expertise - 
                        </p>
                           <ul class="whyus-list">
                            <li>
                                 Ready to Join the Voice Revolution?
                            </li>
                            <li>
                                Let's discuss how Vocbot can empower your business. Contact us today.
                            </li>

                           </ul>
                            
                        
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Start Why-Us Area -->
    <!-- <section class="features-area ptb-110">
    <div class="container">
        <div class="overview-box">
            <div class="content" data-aos="fade-right"
            data-aos-duration="1700">
                <h3 >Make your business more competitive and sustainable.</h3>
                <p>Vocbot is voice-interacting software developed to give users a personalized feel. </p>
                <p>We are a team of passionate professionals who want to address problems that are not easily addressed yet. You may have come across numerous customer calling companies and discovered that they never solve the problem of your customer. </p>
                <p>A lot of people have been experiencing this issue, but instead of finding a solution, they are simply putting up with it. Vocbot is now here to help them. </p>
               
                <ul class="features-list" data-aos="zoom-in-up" data-aos-duration="1200">
                    <li><span><i class='bx bx-check-double'></i> Available 24*7</span></li>
                    <li><span><i class='bx bx-check-double'></i> No IT team required </span></li>
                    <li><span><i class='bx bx-check-double'></i> Respond to queries quickly</span></li>
                    <li><span><i class='bx bx-check-double'></i> Low cost operations & Easy integrations</span></li>
                    <li><span><i class='bx bx-check-double'></i> Real time analysis </span></li>
                    <li><span><i class='bx bx-check-double'></i> Fetch data quickly</span></li>
                    <li><span><i class='bx bx-check-double'></i> Quick Promotional Calls</span></li>
                    <li><span><i class='bx bx-check-double'></i> 100% Customer Satisfaction</span></li>
                </ul>
            </div>

            <div class="image wow zoomIn" data-wow-delay="1s" data-aos="zoom-in-up" data-aos-duration="1500">
                <img src="assets/img/9195061.jpg" alt="image">
            </div>
        </div>
    </div>

    <div class="rectangle-shape1"><img src="assets/img/rectangle-shape1.png" alt="image"></div>
    <div class="rectangle-shape2"><img src="assets/img/rectangle-shape2.png" alt="image"></div>
</section> -->
    <!-- End Features Area -->
</section>